import React from 'react'
import { RedDot } from '../../../components'
// import { Link } from 'react-router-dom'
import { Icon } from '@fluentui/react/lib/Icon'
import { ChevronLeft, ChevronRight } from 'react-feather'

// const Edit = () => <Icon iconName="Edit" className="ms-Edit text-xl" />;
const Delete = () => <Icon iconName="Delete" className="ms-Delete text-xl" />;

const Row = ({data}) => {
  const [open, setOpen] = React.useState(false)

  const actionButtonClasses = "cursor-pointer text-sm text-white h-full flex flex-col items-center justify-center py-5"
  const actionButtonStyles = {
    minWidth: '67px'
  }

  return (
    <tr className="text-sm text-gray-444">
      <td className="relative">
        {/* Desktop */}
        <div className="hidden lg:block">
          <div className="flex items-center">
            <div className="mr-1">{data.order}</div>
            <div>{data.unread && <RedDot />}</div>
          </div>
        </div>

        {/* Mobile */}
        <div className="lg:hidden">
          <div className="flex -mx-2 mt-2 mb-3">
            <div className="w-1/2 px-2">
              <div className="text-gray-999 lg:hidden" style={{fontSize: '10px'}}>Order</div>
              <div className="flex items-center">
                <div className="mr-1">{data.order}</div>
                <div>{data.unread && <RedDot />}</div>
              </div>
            </div>
            <div className="w-1/2 px-2">
              <div className="text-gray-999 lg:hidden" style={{fontSize: '10px'}}>Guests</div>
              {data.guests}
            </div>
          </div>
          <div className="mt-2 mb-2">
            <div className="text-gray-999 lg:hidden" style={{fontSize: '10px'}}>Name</div>
            {data.name}
          </div>

          <div className="hidden absolute right-0 top-0 h-full" style={{width: '67px'}}>
            <div className="relative flex items-center justify-center h-full">
              <ChevronLeft onClick={() => setOpen(true)}/>
              {
                open &&
                <div className="flex items-center absolute top-0 right-0 h-full">
                  <div
                    className="h-full flex items-center justify-end pr-4"
                    style={{width: '183px', background: 'linear-gradient(270deg, #FFFFFF 27.22%, rgba(255, 255, 255, 0) 95.83%)'}}
                    onClick={() => setOpen(false)}
                  >
                    <ChevronRight />
                  </div>
                  <div
                    className={`${actionButtonClasses}`}
                    style={{background: '#999', ...actionButtonStyles}}
                  >
                    <Delete/>
                    <p className="underline mt-2">Delete</p>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </td>
      <td className="hidden lg:table-cell">{data.name}</td>
      <td className="hidden lg:table-cell">{data.guests}</td>
      <td className="align-top lg:align-middle" width="20%">
        <div className="flex items-center justify-end">
          {/* <p className="cursor-pointer underline text-sm text-gray-444 mr-8">
            <Link to="/dashboard/events/form">Edit</Link>
          </p> */}
          <p className="cursor-pointer underline text-sm text-gray-999 mt-2 lg:mt-0">Delete</p>
        </div>
      </td>
    </tr>
  )
}

const Table = ({data}) => {
  return (
    <table className="table table--striped">
      <thead className="hidden lg:table-header-group">
        <tr className="text-xs">
          <th>Order#</th>
          <th>Name</th>
          <th>Guests</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {
          data.map((d, index) => (
            <Row key={index} data={d} />
          ))
        }
      </tbody>
    </table>
  )
}

export { Table }